import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertNewline'
})
export class ConvertNewlinePipe implements PipeTransform {
  private result: string;

  transform(value: string): any {
    if (value) {
      this.result = value.split('&n&').join('<br>'); //ขึ้นบรรทัดใหม่สำหรับตาราง benefit
      this.result = this.result.split('&s&').join('&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'); //เว้นวรรคสำหรับตาราง benefit
      this.result = this.result.split('&ns&').join('<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'); //เว้นวรรคสำหรับตาราง benefit
      return this.result
    } else {
      return '-';
    }

  }

}
